export default __webpack_public_path__ + "fonts/6aa3e782371c03937f7512fe866e1e56.ttf";